import Stores from './containers/Stores';
import { cityStoresSelectors, CityStoresState } from './services/selectors';
import epics from './services/epics';
import reducer from './services/reducer';

export { cityStoresSelectors, epics, CityStoresState, reducer };

export default Stores;



// WEBPACK FOOTER //
// ./src/scenes/CityStores/index.ts